import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actions as LimitsActions } from 'features/betsLimits/redux';
import { convertPostActiveLimitsPayload } from './utils';

export const useBetsLimit = () => {
  const dispatch = useDispatch();
  const { limits } = useSelector((state) => state.betsLimits)

  const [state, setState] = useState({
    digsport: null,
    slots: null,
    liveCasino: null,
  });

  const handleChangeState = useCallback(({ key, value }) => {
    setState((prev) => {
      if (prev[key] === value) return prev;

      return {
        ...prev,
        [key]: value,
      };
    });
  }, []);

  const handleSendLimits = useCallback(() => {
    dispatch(LimitsActions.postActiveLimits(convertPostActiveLimitsPayload(state)))
  }, [state]);

  useEffect(() => {
    setState(limits)
  },[limits])

  useEffect(() => {
    dispatch(LimitsActions.getActiveLimits())
  }, [])

  return useMemo(
    () => ({
      state,
      handlers: {
        handleChangeState,
        handleSendLimits,
      },
    }),
    [state, handleChangeState, handleSendLimits],
  );
};
